// SPDX-License-Identifier: AGPL-3.0-or-later

export const GUILD_TAG_MIN_LENGTH = 2;
export const GUILD_TAG_MAX_LENGTH = 4;
// A tag shows beside names on other servers, where their moderators cannot remove it: upper case Latin and Turkish
// letters and digits only, so no other script can draw a look-alike and no symbol can pass for a mark.
export const GUILD_TAG_PATTERN = /^[0-9A-ZÇĞİÖŞÜ]{2,4}$/;

// Each name is one drawing in the client's badge sprite. No tick, shield or crown: those read as an official mark.
export const GUILD_TAG_BADGE_ICONS = [
	'gamepad',
	'ghost',
	'bomb',
	'target',
	'ufo',
	'magic-wand',
	'masks',
	'music-note',
	'headphones-round-sound',
	'palette',
	'leaf',
	'cat',
	'paw',
	'sun',
	'moon-stars',
	'snowflake',
	'cloud-bolt',
	'planet',
	'football',
	'basketball',
	'dumbbell',
	'incognito',
	'gift',
	'confetti',
] as const;

export const GUILD_TAG_BADGE_COLORS = [
	'#A78BFA',
	'#60A5FA',
	'#22D3EE',
	'#4ADE80',
	'#FACC15',
	'#FB923C',
	'#F87171',
	'#F472B6',
] as const;

// A badge is stored as one number, icon index * colour count + colour index. Once tags are live the colour count is
// fixed and the icon list only grows at its end, or stored badges change meaning.
export const GUILD_TAG_BADGE_COUNT = GUILD_TAG_BADGE_ICONS.length * GUILD_TAG_BADGE_COLORS.length;

export function encodeGuildTagBadge(icon: number, color: number): number {
	return icon * GUILD_TAG_BADGE_COLORS.length + color;
}

export function decodeGuildTagBadge(badge: number): {
	icon: (typeof GUILD_TAG_BADGE_ICONS)[number];
	color: (typeof GUILD_TAG_BADGE_COLORS)[number];
} {
	return {
		icon: GUILD_TAG_BADGE_ICONS[Math.floor(badge / GUILD_TAG_BADGE_COLORS.length)]!,
		color: GUILD_TAG_BADGE_COLORS[badge % GUILD_TAG_BADGE_COLORS.length]!,
	};
}
